import { Component, Input } from '@angular/core';
import { getGalleryYoutubeUrl, isVideoFileUrl } from '@millionshow/common';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
  selector: 'app-gallery-video-player',
  standalone: true,
  imports: [SafePipe],
  host: { style: 'display: block; overflow: hidden;' },
  template: `
    @if (isFile) {
    <video
      [src]="src"
      controls
      playsinline
      preload="metadata"
      [attr.aria-label]="title"
      style="width:100%;height:100%;object-fit:contain;background:#000"></video>
    } @else if (youtubeUrl) {
    <iframe
      [src]="youtubeUrl | safe : 'resourceUrl'"
      [title]="title"
      style="width:100%;height:100%;border:0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen></iframe>
    } @else {
    <p>재생할 수 없는 동영상입니다.</p>
    }
  `,
})
export class GalleryVideoPlayer {
  @Input() src = '';
  @Input() title = '동영상';
  get isFile(): boolean {
    return isVideoFileUrl(this.src);
  }
  get youtubeUrl(): string {
    return getGalleryYoutubeUrl(this.src);
  }
}
